'use strict';

import $ from 'jquery';

class Vector2 {
  constructor(x, y) {
    this.x = x || 0;
    this.y = y || 0;
  }

  scale(num) {
    this.x *= num;
    this.y *= num;
  }

  static distance(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
  }
}

class ParallaxElement {
  constructor(elem, range) {
    this.elem = elem;
    this.range = range;

    this.elem.classList.add('parallax');

    this.curPos = new Vector2();
    this.endPos = new Vector2();

    this.interval;

    this.elem.style.transition = 'none';
  }

  move(x, y) {
    if (window.innerWidth <= 600) {
      this.elem.style.transform = '';
      this.stop();

      return;
    }

    this.endPos.x = this.range * x;
    this.endPos.y = this.range * y;

    this.endPos.scale(2);

    if (!this.interval) {
      this.interval = setInterval(() => {
        this.curPos.x += 0.01 * (this.endPos.x - this.curPos.x);
        this.curPos.y += 0.01 * (this.endPos.y - this.curPos.y);

        this.elem.style.transform = `translate3d(
          ${this.curPos.x}px,
          ${this.curPos.y}px,
          0
        )`;

        if (Vector2.distance(this.curPos, this.endPos) < 1) {
          this.stop();
        }
      });
    }
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
  }
}

const mouseParallax = {
  bind(el, binding) {
    let pe = new ParallaxElement(el, +binding.value.depth || 5);

    el.boundsElem =
      document.getElementById(binding.value.boundsElemId) || document.body;

    // let parentElem = el.parentElement;
    //
    // while (!el.boundsElem) {
    //   if (!parentElem || parentElem == document.body) {
    //     console.log('NULL OR BODY', parentElem);
    //     el.boundsElem = document.body;
    //   } else if (parentElem.id == binding.value.boundsElemId) {
    //     console.log('ID');
    //     el.boundsElem = parentElem;
    //   } else {
    //     parentElem = parentElem.parentElement;
    //   }
    // }

    el.mpOnMouseMove = e => {
      let x = 1 - e.pageX / (window.innerWidth * 0.5);
      let y = 1 - e.pageY / (window.innerHeight * 0.5);

      pe.move(x, y);
    };

    el.mpOnMouseLeave = () => {
      pe.move(0, 0);
    };

    // el.boundsElem.addEventListener('mousemove', el.mpOnMouseMove);
    // el.boundsElem.addEventListener('mouseleave', el.mpOnMouseLeave);
    document.body.addEventListener('mousemove', el.mpOnMouseMove);
    document.body.addEventListener('mouseleave', el.mpOnMouseLeave);
  },
  unbind(el) {
    // el.boundsElem.removeEventListener('mousemove', el.mpOnMouseMove);
    // el.boundsElem.removeEventListener('mouseleave', el.mpOnMouseLeave);
    document.body.removeEventListener('mousemove', el.mpOnMouseMove);
    document.body.removeEventListener('mouseleave', el.mpOnMouseLeave);
  }
};

export default mouseParallax;



// WEBPACK FOOTER //
// ./src/directives/mouse-parallax.js